import DfpManager from './lib/dfpManager';

export enum ZPG_DFP_NETWORK {
    ID = '9215'
}

export enum AD_UNIT_ROOTS {
    TEXT_LINK = '/ZPG/Zoopla/Text-Links',
    MPU = '/ZPG/Zoopla/MPU',
    PARTNERSHIP = '/ZPG/Zoopla/Partnership-Ads',
    SKY_SCRAPER = '/ZPG/Zoopla/Skyscraper',
    INTERSTITIAL = '/ZPG/Zoopla/Interstitial',
    FOOTER = '/ZPG/Zoopla/Footer-Leaderboard'
}

export enum AD_UNIT_PAGES {
    TO_RENT_LSRP = '/To-Rent-LSRP',
    TO_RENT = '/To-Rent',
    FOR_SALE_LSRP = '/For-Sale-LSRP',
    FOR_SALE = '/For-Sale',
    NEW_HOMES = '/New-Homes',
    UNKNOWN = '/UNKNOWN'
}

export enum DFP_AD_UNIT {
    DEFAULT = '/ZPG/Zoopla/for-sale',
    ZOOPLA_EXPERIAN_LOANSWAREHOUSE_MOBILE = '/zoopla-mobile-loanswarehouse-experian',
    ZOOPLA_EXPERIAN_LOANSWAREHOUSE_MOBILE_EXPERIMENT = '/zoopla-mobile-loanswarehouse-experian-experiment',
    ZOOPLA_LDP_FOR_SALE_DESKTOP = '/sponsorship/zoopla/desktop/for-sale/details',
    ZOOPLA_LDP_FOR_SALE_MOBILE = '/sponsorship/zoopla/mobile/for-sale/details',
    ZOOPLA_LDP_TO_RENT_DESKTOP = '/sponsorship/zoopla/desktop/to-rent/details',
    ZOOPLA_LDP_TO_RENT_MOBILE = '/sponsorship/zoopla/mobile/to-rent/details',
    ZOOPLA_LDP_NEW_HOMES_DESKTOP = '/sponsorship/zoopla/desktop/new-homes/details',
    ZOOPLA_LDP_NEW_HOMES_MOBILE = '/sponsorship/zoopla/mobile/new-homes/details',
    ZOOPLA_LDP_OVERSEAS_DESKTOP = '/sponsorship/zoopla/desktop/overseas/details',
    ZOOPLA_LDP_OVERSEAS_MOBILE = '/sponsorship/zoopla/mobile/overseas/details',
    VALUATION_BOOSTER = '/zoopla-valuation-booster',
    ZOOPLA_NATIVE_FEATURED_LISTING_TEST = '/zoopla-mobile-featured-listings-live-test'
}

// Option to include a size or a keyword e.g. 400x400 or 'fluid'
export type Size = [number, number] | 'fluid';
type MediaQueryDirection = '>' | '<';
export type Breakpoint = [MediaQueryDirection, number];

export type GoogleTag = any; // eslint-disable-line @typescript-eslint/no-explicit-any

export type CustomWindow = Window &
    typeof globalThis & {
        googletag: GoogleTag;
    };

export type DfpTargeting = {
    [key: string]: string | string[];
};

export type Slot = {
    id: string;
    sizes: Size[];
    adUnitPath: string /* === DfpNetworkId + AdUnitCode */;
    position: number;
    collapseEmpty?: boolean;
    isDefined?: boolean;
    hideFromSizeUp?: number;
    hideFromSizeDown?: number;
};

export type Slots = { [id: string]: Slot };

export type ConsentCategory = { id: number; consentGiven: boolean };

export type AdvertContextType = {
    dfpInitialised: boolean;
    slots: Slots;
    targeting: DfpTargeting;
    adUnitCode: DFP_AD_UNIT;
    dfpNetworkId: ZPG_DFP_NETWORK.ID;
    showPlaceHolderContent: boolean;
    reportAdSlotId?: string;
    debugMode: boolean;
    reportMode: boolean;
    reportAdSlotPosition?: number;
    dfpManager?: DfpManager;
};

export enum ACTION_TYPE {
    MOUNT_SLOT = 'MOUNT_SLOT',
    SET_TARGETING = 'SET_TARGETING',
    SET_INITIALISED = 'SET_INITIALISED',
    UNMOUNT_SLOT = 'UNMOUNT_SLOT',
    REPORT_MODE = 'REPORT_MODE',
    REPORT_SLOT = 'REPORT_SLOT',
    SET_DFP_MANAGER = 'SET_DFP_MANAGER',
    REFRESH = 'REFRESH'
}

export type AdvertContextAction =
    | { type: ACTION_TYPE.MOUNT_SLOT; payload: Slot }
    | { type: ACTION_TYPE.UNMOUNT_SLOT; payload: { id: string } }
    | { type: ACTION_TYPE.SET_TARGETING; payload: DfpTargeting }
    | { type: ACTION_TYPE.SET_INITIALISED }
    | { type: ACTION_TYPE.REPORT_MODE }
    | {
          type: ACTION_TYPE.REPORT_SLOT;
          payload: { id: string; position: number };
      }
    | { type: ACTION_TYPE.SET_DFP_MANAGER; payload: DfpManager }
    | { type: ACTION_TYPE.REFRESH };

export enum MOBILE_AD_VARIATE_TYPE {
    EXPERIAN = 'EXPERIAN',
    VARIATION_1 = 'VARIATION_1',
    VARIATION_2 = 'VARIATION_2'
}

export type MobileAdVariations = {
    [MOBILE_AD_VARIATE_TYPE.EXPERIAN]: number;
    [MOBILE_AD_VARIATE_TYPE.VARIATION_1]: number;
    [MOBILE_AD_VARIATE_TYPE.VARIATION_2]: number;
};

export type StyledAdSlotProps = {
    width?: number;
    height?: number;
    breakpoint?: Breakpoint;
};

export type RecordedAdData = {
    creativeId?: number;
    sourceAgnosticCreativeId?: number;
};

export type SlotRenderEndedEvent = {
    slot: {
        getSlotElementId: () => string;
    };
    creativeId?: number;
    sourceAgnosticCreativeId?: number;
};
